import React, { Fragment, useState } from 'react';
import * as Yup from 'yup';
import { Formik } from 'formik';
import { makeStyles } from '@material-ui/core/styles';

import api from '../../services/api';

import EditImage from '../../utils/editImage';
import Alerts from '../../utils/alerts';

import {
    Typography,
    Divider,
    Dialog,
    DialogContent,
    DialogTitle,
    Box,
    Button,
    TextField,
    Grid,
    Avatar,
    colors
} from '@material-ui/core';

import DeleteRoundedIcon from '@material-ui/icons/DeleteRounded';

const useStyles = makeStyles((theme) => ({
    root: {
    },
    avatar: {
        marginRight: theme.spacing(2),
        marginTop: theme.spacing(2),
        color: colors.cyan[300],
        backgroundColor: colors.grey[200],
        width: 290,
        height: 290
    }
}));

const Hardware = ({ item, open, closeEdition, updateValues, dependencies, clearImage }) => {

    const classes = useStyles();

    const [openAlert, setOpenAlert] = useState(false);
    const [message, setMessage] = useState({});

    const [openChangeImageDialog, setOpenChangeImageDialog] = useState(false);

    const openChangeImage = (item) => {
        setOpenChangeImageDialog(true);
    }

    const closeChangeImageDialog = () => {
        setOpenChangeImageDialog(false);
    }

    const closeAlert = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
    };

    const saveChangeImage = (values, file) => {
        const data = new FormData();
        data.append('hardware', item._id);
        data.append('file', file);
        api.post('/hardwares/imagem', data, { hardware: values._id }, {
            onUploadProgress: e => {
                console.debug((e.loaded * 100) / e.total);
            }
        }).then((response) => {
            if (!response.data.error) {
                values.image = response.data.name;
                closeChangeImageDialog();
            } else {
                setMessage(response.data);
                setOpenAlert(true);
            }
        }).catch((error) => {
            console.error(error);
            setMessage({ error: true, fatal: true, message: "Erro ao alterar Imagem do Hardware. ", detail: error.message });
            setOpenAlert(true);
        });
    }

    return (
        <Fragment>

            <Alerts message={message}
                open={openAlert}
                closeAlert={closeAlert} />

            <EditImage
                item={item}
                open={openChangeImageDialog}
                close={closeChangeImageDialog}
                save={saveChangeImage}
            ></EditImage>


            <Dialog aria-modal="true" open={open} aria-labelledby="form-dialog-title" maxWidth="md" className={classes.root} fullWidth>
                <DialogTitle id="form-dialog-title">
                    <Typography
                        color="textPrimary"
                        variant="h4">
                        Hardware
                    </Typography>
                </DialogTitle>
                <Divider />
                <DialogContent>
                    <Formik
                        initialValues={item}
                        validationSchema={
                            Yup.object().shape({
                                code: Yup.string().required('Código é obrigatório'),
                                variant: Yup.string().required('Variante é obrigatória'),
                                name: Yup.string().required('Nome é obrigatório'),
                                platform: Yup.string().required('Plataforma é obrigatória'),
                                manufacturer: Yup.string().required('Frequência Dados é o obrigatória')
                            })
                        }
                        onSubmit={(values, formik) => {
                            updateValues(values);
                            formik.setSubmitting(false);
                        }}

                    >

                        {({
                            errors,
                            handleBlur,
                            handleChange,
                            setFieldValue,
                            handleSubmit,
                            isSubmitting,
                            touched,
                            values
                        }) => (
                            <form onSubmit={handleSubmit}>

                                <Grid
                                    container
                                    xs="auto"
                                >

                                    <Grid
                                        item
                                        md={4}
                                        xs={12}
                                    >

                                        <Grid
                                            container
                                            spacing={2}
                                        >

                                            <Grid
                                                item
                                            >
                                                <Avatar variant='rounded' id="hardwareImage" name="hardwareImage"
                                                    className={classes.avatar}
                                                    src={(item.image) ? process.env.REACT_APP_API_ENDPPOINT + '/hardwares/' + item.image : null}
                                                >
                                                    Sem Imagem
                                                </Avatar>

                                            </Grid>

                                        </Grid>
                                        <br></br>
                                    </Grid>

                                    <Grid
                                        item
                                        md={8}
                                        xs={12}>

                                        <Grid
                                            container
                                            spacing={2}
                                        >

                                            <Grid
                                                item
                                                md={6}
                                                xs={12}>

                                                <TextField
                                                    error={Boolean(touched.code && errors.code)}
                                                    required
                                                    fullWidth
                                                    label="Código"
                                                    margin="normal"
                                                    name="code"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.code}
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                    InputProps={{ readOnly: false }}
                                                />

                                            </Grid>

                                            <Grid
                                                item
                                                md={6}
                                                xs={12}>
                                                <TextField
                                                    error={Boolean(touched.variant && errors.variant)}
                                                    fullWidth
                                                    required
                                                    label="Variante"
                                                    margin="normal"
                                                    name="variant"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.variant}
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                    InputProps={{ readOnly: false }}
                                                />
                                            </Grid>

                                            <Grid
                                                item
                                                md={12}
                                                xs={12}>
                                                <TextField
                                                    error={Boolean(touched.name && errors.name)}
                                                    fullWidth
                                                    label="Nome"
                                                    margin="none"
                                                    name="name"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.name}
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            </Grid>

                                            <Grid
                                                item
                                                md={6}
                                                xs={12}>
                                                <TextField
                                                    error={Boolean(touched.platform && errors.platform)}
                                                    fullWidth
                                                    label="Plataforma"
                                                    margin="none"
                                                    name="platform"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.platform}
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            </Grid>

                                            <Grid
                                                item
                                                md={6}
                                                xs={12}>
                                                <TextField
                                                    error={Boolean(touched.manufacturer && errors.manufacturer)}
                                                    fullWidth
                                                    label="Fabricante"
                                                    margin="none"
                                                    name="manufacturer"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.manufacturer}
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            </Grid>

                                            <Grid
                                                item
                                                md={12}
                                                xs={12}>

                                                <Grid
                                                    container
                                                    spacing={1}
                                                >

                                                    <Grid
                                                        item>
                                                        <Button
                                                            disabled={isSubmitting || !values.image}
                                                            color="secondary"
                                                            size="medium"
                                                            children={<DeleteRoundedIcon />}
                                                            onClick={(e) => {
                                                                clearImage(values)
                                                            }}
                                                            variant="outlined"></Button>
                                                    </Grid>

                                                    <Grid
                                                        item>
                                                        <Button
                                                            disabled={isSubmitting || !item._id}
                                                            color="secondary"
                                                            size="medium"
                                                            onClick={() => { openChangeImage(values) }}
                                                            variant="outlined">
                                                            Atualizar a Imagem
                                                        </Button>
                                                    </Grid>

                                                </Grid>

                                            </Grid>

                                        </Grid>

                                    </Grid>

                                </Grid>

                                <Box my={1}></Box>
                                <Divider />

                                <Box my={1}>
                                    <Grid container
                                        direction="row"
                                        justify="flex-end"
                                        alignItems="baseline"
                                        spacing={1}  >
                                        <Grid item >
                                            <Button
                                                color="secondary"
                                                disabled={isSubmitting}
                                                size="small"
                                                type="submit"
                                                variant="contained">
                                                Salvar
                                            </Button>
                                        </Grid>
                                        <Grid item >
                                            <Button
                                                color="secondary"
                                                disabled={isSubmitting}
                                                size="small"
                                                variant="contained"
                                                onClick={() => { closeEdition() }}>
                                                Cancelar
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Box>

                            </form>
                        )}
                    </Formik>

                </DialogContent>

            </Dialog>

        </Fragment>
    );
};

export default Hardware;
